export default __webpack_public_path__ + "static/media/expl-nn_06_DE.da752491.png";